<div class="adandoned-reservation-header" *ngIf="!!translationType">
  <h3>{{'ADANDONED_RESERVATION_MODULE.' + translationType + '.HEADER' | transloco : { user: user?.first_name } }}</h3>
</div>